import { SearchResultEvent } from '../../../data/schema/SubstrateSearchResponse';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import CalendarItemTypeType from 'owa-service/lib/contract/CalendarItemTypeType';
import {
    convertRecipientToSingleRecipientType,
    convertToFolderId,
    convertToItemId,
    convertSearchSortOrder,
} from '../../../helpers/substrateTransformations/response/converterHelpers';

const DEFAULT_ITEMCLASS: string = 'IPM.Appointment';

export default function convertSearchResultEventToCalendarItemType(
    searchResult: SearchResultEvent
): CalendarItem {
    return {
        CalendarItemType: searchResult.CalendarItemType.toString() as CalendarItemTypeType,
        Categories: searchResult.Categories,
        CharmId: searchResult.Charm,
        DisplayTo: searchResult.DisplayTo,
        End: searchResult.End,
        Start: searchResult.Start,
        HasAttachments: searchResult.HasAttachments,
        IsAllDayEvent: searchResult.IsAllDayEvent,
        IsMeeting: searchResult.IsMeeting,
        IsMeetingPollEvent: searchResult.IsMeetingPollEvent,
        ItemClass: searchResult.ItemClass ? searchResult.ItemClass : DEFAULT_ITEMCLASS,
        FreeBusyType: searchResult.LegacyFreeBusyStatus.toString(),
        Location: { DisplayName: searchResult.Location },
        Sensitivity: searchResult.Sensitivity,
        SeriesId: searchResult.SeriesMasterItemId ? searchResult.SeriesMasterItemId.Id : null,
        Subject: searchResult.Subject,
        Organizer: convertRecipientToSingleRecipientType(searchResult.Organizer),
        UID: searchResult.UID,
        ItemId: convertToItemId(searchResult.ItemId),
        ParentFolderId: convertToFolderId(searchResult.ParentFolderId),
        SortOrderSource: convertSearchSortOrder(searchResult.SortOrderSource),
        Preview: searchResult.Preview,
    };
}
